import { render, staticRenderFns } from "./ChiefComplaintCreateEditModal.vue?vue&type=template&id=8df0fab4&"
import script from "./ChiefComplaintCreateEditModal.vue?vue&type=script&lang=js&"
export * from "./ChiefComplaintCreateEditModal.vue?vue&type=script&lang=js&"
import style0 from "./ChiefComplaintCreateEditModal.vue?vue&type=style&index=0&id=8df0fab4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports